(() => {
  function initializeAboutPage() {
    const main = document.querySelector(".template-page-about-us #MainContent");
    if (!main || main.dataset.aboutInitialized === "true") return;

    const sections = [...main.querySelectorAll(".ormsby-section-container")];
    if (sections.length < 3) return;

    main.dataset.aboutInitialized = "true";
    sections[0].classList.add("about-story");
    sections[1].classList.add("about-founder");
    sections[2].classList.add("about-team");

    sections.slice(1).forEach((section) => {
      section.querySelectorAll(".flex-item").forEach((card) => {
        const name = card.querySelector(".block-title")?.textContent.trim();
        const image = card.querySelector("img");
        if (image && name && (!image.alt || image.alt.toLowerCase() === "image description")) {
          image.alt = `${name}, Ormsby Guitars team`;
        }
      });
    });

    sections[2].querySelectorAll(".flex-item").forEach((card) => {
      const profile = card.querySelector(".enhanced-richtext");
      const paragraphs = profile ? [...profile.querySelectorAll(":scope > p")] : [];
      if (!profile || !paragraphs.length) return;

      const details = document.createElement("details");
      details.className = "about-team__details";
      const summary = document.createElement("summary");
      summary.textContent = "Quick profile";
      const content = document.createElement("div");
      content.className = "about-team__details-content";

      paragraphs.forEach((paragraph) => content.append(paragraph));
      details.append(summary, content);
      profile.append(details);
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initializeAboutPage);
  } else {
    initializeAboutPage();
  }

  document.addEventListener("shopify:section:load", initializeAboutPage);
})();
